import { render, staticRenderFns } from "./deductionDetail-safe.vue?vue&type=template&id=8f0dcc4c&scoped=true"
import script from "./deductionDetail-safe.vue?vue&type=script&lang=js"
export * from "./deductionDetail-safe.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail-safe.vue?vue&type=style&index=0&id=8f0dcc4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0dcc4c",
  null
  
)

export default component.exports